<script>
import baseList from '@/views/components/base/baseList.vue'
import { Tag, Button } from 'view-design'
// import Vue from 'vue'
// import Info from './info.vue'
// import Repair from './repair.vue'
// import Track from './track.vue'
export default {
  extends: baseList,
  components: {
    // info: Info,
    // Repair,
    // Track,
  },
  data() {
    return {
      table: {
        mname: 'smsLog',
        key: 'id',
         url: {
            // del: '/admin/system/desk'
        },
        output: false,
      },
      actions: [
        // {
        //   label: '新增科室',
        //   icon: 'md-add',
        //   onClick: this.toAdd,
        // type: "success",
        //   auth: '',
        // },
        // {
        //   label: '导入',
        //   icon: 'md-add',
        //   onClick: this.toImport,
        //   auth: '',
        // },
        // {
        //   label: '下载模板',
        //   icon: '',
        //   onClick: this.toDownload,
        //   auth: '',
        // },
      ],
      menus: [
        // {
        //   label: "配置列表",
        //   name: "configure_list",
        //   auth: "/admin/configure/lists",
        // },
        // {
        //   label: "坐席列表",
        //   name: "callConfig_list",
        //   auth: "/admin/callConfig/lists",
        // },
        // {
        //   label: "公告列表",
        //   name: 'notice_list',
        //   auth: '/admin/configure/lists',
        // },
        // {
        //   label: "操作日志",
        //   name: "operlog_list",
        //   auth: "/admin/operlog/lists",
        // },
        // {
        //   label: "登录日志",
        //   name: "logininfor_list",
        //   auth: "/admin/logininfor/lists",
        // },

        // {
        //   label: "投诉管理",
        //   name: "feedback_list",
        //   auth: "/admin/feedback/lists",
        // },
      ],
      filters: [
        {
          label: '操作模块',
          name: 'title',
          value: '',
          KeyEnter : this.search,
          type: 'input',
        },
        {
          label: "操作状态",
          name: "status",
          value: "",
          KeyEnter : this.search,
          type: "select",
          dropList: [
            {
              value: 0,
              name: "成功",
            },
            {
              value: 1,
              name: "失败",
            },
          ],
        },
        {
          label: '操作类型',
          name: 'businessType',
          value: '',
          KeyEnter : this.search,
          type: 'select',
          dropList: [
          {
            value:0,
            name:'其它'
          },
          {
            value:1,
            name:'新增'
          },{
            value:2,
            name:'修改'
          },{
            value:3,
            name:'删除'
          },{
            value:4,
            name:'授权'
          },{
            value:5,
            name:'导出'
          },{
            value:6,
            name:'导入'
          },{
            value:7,
            name:'强退'
          },{
            value:8,
            name:'生成代码'
          },{
            value:9,
            name:'清空数据'
          },
          ],
        },
      ],
      tableCols: [
        {
          title: '日志编号',
          key: 'operId',
          minWidth: 120,
          align: 'center',
        },
        {
          title: '操作模块',
          key: 'title',
          minWidth: 120,
          align: 'center',
        },
        {
          title: '操作类型',
          key: 'businessType',
          minWidth: 120,
          align: 'center',
          render: (h, params) => {
            const row = params.row;
            const text =
              row.status == 0 ? "其他" : 
              row.status == 1 ? "新增" :
              row.status == 2 ? "修改" : 
              row.status == 3 ? "删除" : 
              row.status == 4 ? "授权" : 
              row.status == 5 ? "导出" : 
              row.status == 6 ? "导入" : 
              row.status == 7 ? "强退" : 
              row.status == 8 ? "生成代码" : 
              row.status == 9 ? "清空数据" :  
              "";
            return (
              <span style={{  "font-size": "14px" }}>{text}</span>
            );
          },
        },
        {
          title: '请求方式',
          key: 'requestMethod',
          minWidth: 120,
          align: 'center',
        },
        {
          title: '操作地址',
          key: 'operIp',
          minWidth: 120,
          align: 'center',
        },
        {
          title: '操作人',
          key: 'operName',
          minWidth: 120,
          align: 'center',
        },
        {
          title: "操作状态",
          key: "status",
          width: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const color =
              row.status == 0 ? "blue" : row.status == 1 ? "red" : "";
            const text =
              row.status == 0 ? "成功" : row.status == 1 ? "失败" : "";
            return (
              <span style={{ color: color, "font-size": "14px" }}>{text}</span>
            );
          },
        },
        {
          title: '操作时间',
          width: 115,
          align: 'center',
          key: 'operTime',
          render: (h, params) => {
            const row = params.row;
            const text = row.operTime.slice(0, 16);
            return <span>{text}</span>;
          },
        },
      //  {
      //               title: '操作',
      //               align: 'center',
      //               width: 160,
      //               key: 'handle',
      //               handle: [
      //                 // 'edit', 
      //                 // 'delete'
      //                 ]
      //           }
      ],
    }
  },
  created() {
    this.loadLevelData()
  },
  methods: {
     loadLevelData() {
      // 通过pk查询字典数据
      let q = {}
      // q.state=1
      $utils.api.load('/admin/system/desk/selectList', q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows
          let dropList = []
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index]
            let xx = {}
            xx.value = element.deskName
            xx.name = element.deskName
            xx.children = element.children || []
            dropList.push(xx)
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index]
            if (element && element.name == 'deskName') {
              this.filters[index]['dropList'] = (element['dropList'] || []).concat(dropList)
            }
          }
        }
      })
    },
    // toAdd() {
    //   $utils.url.push({ name: 'offices_add', query: { action: 'add' } })
    // },
    //  handleEdit(currentRow){
    //   $utils.url.push({ name: "offices_edit", query: {action: "edit",kv:currentRow.id } });
    // },
    //转单
    // toChange(row) {},
    //详情
    // toInfo(row) {
    //   $utils.url.push({
    //     name: 'knowledgeBase_info',
    //     query: { action: 'edit', kv: row.id },
    //   })
    // },
    //导出
    toImport() {},
    //下载模板
    toDownload() {},
  },
}
</script>
<style scoped></style>
